import React from 'react';

interface Props {
    value: string;
    handleChange: (event: React.ChangeEvent) => void;
}

export default function SearchInput({ value, handleChange }: Props) {
    return (
        <>
            <input
                type='text'
                value={value}
                onChange={handleChange}
                className='form-control search '
                placeholder='Buscar...'
            />
        </>
    );
}
